module.exports = __webpack_public_path__ + "img/helene_d.6a004d9c.png";